<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Panel, useVueFlow } from '@vue-flow/core';
import Button from 'dashboard/components-next/button/Button.vue';

const { viewport, minZoom, maxZoom, zoomIn, zoomOut, fitView } = useVueFlow();
const percentage = computed(() => `${Math.round(viewport.value.zoom * 100)}%`);
const { t } = useI18n({
  useScope: 'local',
  messages: {
    en: {
      zoom: 'Canvas zoom',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      fit: 'Show entire flow',
    },
    ru: {
      zoom: 'Масштаб схемы',
      zoomIn: 'Приблизить',
      zoomOut: 'Отдалить',
      fit: 'Показать всю схему',
    },
  },
});
</script>

<template>
  <Panel
    position="top-left"
    class="flex items-center gap-1 p-1 border rounded-xl shadow-sm bg-n-solid-1 border-n-weak"
    role="group"
    :aria-label="t('zoom')"
  >
    <Button
      icon="i-lucide-minus"
      variant="ghost"
      color="slate"
      :title="t('zoomOut')"
      :aria-label="t('zoomOut')"
      :disabled="viewport.zoom <= minZoom"
      @click="zoomOut()"
    />
    <output class="w-12 text-xs text-center tabular-nums text-n-slate-12">
      {{ percentage }}
    </output>
    <Button
      icon="i-lucide-plus"
      variant="ghost"
      color="slate"
      :title="t('zoomIn')"
      :aria-label="t('zoomIn')"
      :disabled="viewport.zoom >= maxZoom"
      @click="zoomIn()"
    />
    <div class="w-px h-5 mx-1 bg-n-weak" aria-hidden="true" />
    <Button
      icon="i-lucide-scan"
      variant="ghost"
      color="slate"
      :title="t('fit')"
      :aria-label="t('fit')"
      @click="fitView({ padding: 0.2 })"
    />
  </Panel>
</template>
